export default "__VITE_ASSET__CUvLoFFB__"